import { supabase } from '@/lib/supabaseClient';
import type {
  SignInWithPasswordCredentials,
  SignUpWithPasswordCredentials,
} from '@supabase/supabase-js';

/**
 * Signs up a new user.
 */
export async function signUpUser(credentials: SignUpWithPasswordCredentials) {
  const { data, error } = await supabase.auth.signUp(credentials);

  if (error) {
    console.error('Error signing up:', error.message);
  }

  return { data, error };
}

/**
 * Signs in an existing user with their email and password.
 
 */
export async function signInUser(credentials: SignInWithPasswordCredentials) {
  const { data, error } = await supabase.auth.signInWithPassword(credentials);

  if (error) {
    console.error('Error signing in:', error.message);
  }

  return { data, error };
}

/**
 * Signs out the currently authenticated user.
 */
export async function signOutUser() {
  return await supabase.auth.signOut();
}

/**
 * Sends a password reset email to the provided address.
 */
export async function sendPasswordResetEmail(email: string) {
  return await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/login`,
  });
}
/**
 * Sends a password reset email to the provided address.
 */

export const resetPassword = async (
  token: string,
  newPassword: string
): Promise<{ error?: { message: string } }> => {
  // The token is the refresh_token, which is now automatically handled by the client.
  // We just need to update the user. The session should be automatically refreshed
  // by the Supabase client library upon successful password reset navigation.

  const { data, error } = await supabase.auth.updateUser({
    password: newPassword,
  });

  if (error) {
    console.error('Error resetting password:', error.message);
    return {
      error: { message: error.message || 'Failed to reset password.' },
    };
  }

  // Success
  return { error: undefined };
};